// extracted by mini-css-extract-plugin
export default {"label":"Phone_label__DTwjV","wrapper":"Phone_wrapper__Ii8wk"};